<h2 mat-dialog-title>
  Buying Power & Positions
  <mat-icon
    [svgIcon]="'hint_icon'"
    [matTooltip]="buyingPositionTooltip"
    [matTooltipPosition]="'below'"
    class="header-help-icon small-icon"
  ></mat-icon>
  <button
    mat-icon-button
    mat-dialog-close
    class="popup-close-btn"
    tabindex="-1"
  >
    <mat-icon
      [svgIcon]="'close-icon'"
      class="close-modal-icon small-icon"
    ></mat-icon>
  </button>
</h2>

<form
  [formGroup]="positionSettingForm"
  (ngSubmit)="updateSetting()"
  class="form-design"
>
  <mat-dialog-content class="mat-typography">
    <div class="risk-based-position-sizing">
      <div class="risk-input">
        <div class="per-input">
          <label>Buying Power</label>
          <div class="input-box w-100">
            <div class="percentage">$</div>
            <input
              [inputMask]="buyingPowerInputMask"
              (focus)="$event.target.select()"
              (blur)="inputBlur('buyingPower')"
              type="text"
              tabindex="1"
              formControlName="buyingPower"
              min="1"
              step="1"
              maxlength="11"
              required
            />
          </div>
        </div>

        <div class="icon-input">
          <label>Positions</label>
          <div class="input-box w-100">
            <input
              [inputMask]="positionInputMask"
              (focus)="$event.target.select()"
              (blur)="inputBlur('position')"
              type="text"
              formControlName="position"
              maxlength="2"
              tabindex="2"
              step="1"
              required
              min="1"
              max="99"
            />
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button
      mat-flat-button
      color="primary"
      class="fill-btn small-btn"
    >
      Set
    </button>
  </mat-dialog-actions>
</form>
